module.exports = "//static.hsappstatic.net/connect-dot-com-public-ui/static-1.486/images/homepageCardImages/profile-bg.svg"